import { getAuth, RecaptchaVerifier } from 'firebase/auth';
import { useEffect } from 'react';
import { setError } from '../services/Errors';

const Recaptcha = () => {
  const auth = getAuth();
  auth.languageCode = 'no';

  useEffect(() => {
    try {
      window.recaptchaVerifier = new RecaptchaVerifier(
        'recaptcha',
        {
          'expired-callback': () => {
            // TODO: Ask user to solve recaptcha again
            console.warn('Recaptcha expired. Please solve recaptcha again to continue.');
          },
        },
        auth
      );
    } catch (error) {
      setError('unknown', error.message);
    }

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
  }, [auth]);

  return <div id="recaptcha" style={{ height: '76px' }}></div>;
};

export default Recaptcha;
